module.exports = __webpack_public_path__ + "img/triangle-100.8063a57e.gif";